import { createLead } from '../../../utils/common-lead-apis';
import {
  getUTMParameters,
  setUTMParamInCookie,
} from '../../../utils/cookieUtils';
import { handleTrack } from '../../../utils/tracker';
import { BusinessFormType, CAFormType } from '../../ContactSales/utils/types';
import { TLeadDataConstants } from '../../ContactSales/utils/utils';
import {
  FORM_ACTION,
  LOCAL_STORAGE,
} from '../../Webinars/Common/WebinarLeadForm/FormData/formConstants';
import { FORM_DATA } from '../../Webinars/Common/WebinarLeadForm/Utils/types';

export interface ISEND_GATED_ASSET_DATA {
  formData: Partial<BusinessFormType | CAFormType> & TLeadDataConstants;
  token: string;
}

interface ITRACK_FORM {
  data: Record<string, FORM_DATA>;
  formAction: FORM_ACTION;
  buttonText: string;
}

export const sendGatedAssetData = ({
  formData,
  token,
}: ISEND_GATED_ASSET_DATA): Promise<string> => {
  if (typeof window === 'undefined') {
    return Promise.reject('Window does not exist');
  }
  setUTMParamInCookie(window.location.search);
  return createLead(
    {
      lead_data: {
        ...formData,
      },
      lead_platforms: {},
    },
    token
  );
};

export const setLocalStorageLeadSubmitted = (isLeadSubmitted: boolean) => {
  if (!window.localStorage) return;
  localStorage.setItem(LOCAL_STORAGE.IS_LEAD_SUBMITTED, `${isLeadSubmitted}`);
};

export const checkIsLeadSubmitted = (): boolean => {
  const leadSubmitted = localStorage.getItem(LOCAL_STORAGE.IS_LEAD_SUBMITTED);
  return leadSubmitted === 'true' ? true : false;
};

export const getGatedAssetLeadData = (formData: Record<string, FORM_DATA>) => {
  const { firstName, lastName, email, phone, designation, companyName } =
    formData;

  return {
    email: email?.value || '',
    name: firstName?.value + ' ' + lastName?.value || '',
    phone_number: phone?.value || '',
    lead_source_url: window.location.href || '',
    designation: designation?.value || null,
    company_name: companyName?.value || null,
    form_type: 'Gated_Asset',
    lead_type: 'case-study-leads',
    note: 'Lead from Gated Assets',
    leadType: 'case-study-leads', //TODO: is this required? as we already have lead_type
    lead_source_page: window.location.href || '',
    lead_creation_time: Math.floor(new Date().getTime() / 1000),
    type_name: 'CA',
    ...getUTMParameters(),
  };
};

export const trackForm = ({ data, formAction, buttonText }: ITRACK_FORM) => {
  const formKeys = Object.keys(data);
  const getErrors = {} as Record<string, string | undefined>;
  const getData = {} as Record<string, string | undefined>;

  formKeys.forEach((key) => {
    getErrors[key] = data[key]?.errors.message;
    getData[key] = data[key]?.value;
  });

  const trackValue =
    formAction === FORM_ACTION.ERROR
      ? { form_errors: getErrors }
      : { ...getData };

  handleTrack({
    action: formAction,
    label: `form_${buttonText}`,
    valueObj: trackValue,
  });
};
